<template>
	<div v-if="!loading">
		<div ref="statsFilter" class="static">
      <div class="bg-zt-bg-main-td border-b border-b-zt-light xl:border-b-0 xl:!shadow-none">
        <FootballStatsFilter analytic-type="compare-results" class="bg-[#242e3d] border-x border-zt-light"
                             :class="{ 'border-t pt-2' : view === 'a' }"
                             :is-league-results="true" :options="filteringOptions"
                             :home-away-only="view === 'b'"
                             @filtering-changed="(value) => changeFilters(value)"/>
        <div class="border-t border-x border-x-zt-light border-t-zt-light text-xs font-medium
                    text-zt-more py-2.5 bg-[#242e3d] px-2">
		       <div class="flex justify-center -translate-x-[1px]">
		         <button :class="{ '!bg-zt-light text-white' : homeAway === 'all' }" @click="changeHomeAway('all')"
		                 class="hover:bg-zt-light/35 transition-colors uppercase  h-[28px] w-[113px] border border-r-0
		                       border-zt-light rounded-l-[5px]">
			         Ogółem
		         </button>
		         <button :class="{ '!bg-zt-light text-white' : homeAway === 'home/away' }" @click="changeHomeAway('home/away')"
		                 class="hover:bg-zt-light/35 transition-colors uppercase h-[28px] w-[113px] border rounded-r-zt border-zt-light">
			         Dom/Wyjazd
		         </button>
		       </div>
        </div>
      </div>
		</div>
		<div v-if="view === 'a'" class="border-zt-light overflow-x-hidden xl:border-t">
			<div class="grid grid-cols-1 xl:grid-cols-2" :class="{ 'grid-cols-2' : mobileView === 'b' }">
				<div class="flex flex-col">
					<div class="bg-zt-light-full border-b border-x border-zt-light py-2.5 pl-2 text-xs uppercase flex flex-nowrap
					            items-center !h-[41px] max-h-[41px]" :class="[loading ? 'h-fit' : 'h-full']">
            <img class="w-5 h-5 aspect-square object-contain mr-2"
                 @error="$event.target.src='/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
                 :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${teamAQueryName}.png`"
                 :alt="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"/>
						<span v-if="mobileView === 'a'">Mecze {{ homeAway === 'home/away' ? 'domowe' : teamADetails.country === 'World' ? '' : 'ligowe' }}
              - {{teamADetails.shortname ? teamADetails.shortname : teamAName }} </span>
						<span class="truncate" v-else>{{teamADetails.shortname ? teamADetails.shortname : teamAName }}</span>
            <div v-if="selectedFilters[0] === 'halfs'" class="flex flex-nowrap ml-auto mr-[21px] xl:!mr-[25px] gap-x-2 relative font-['lato']">
              <span class="lowercase" :class="{'opacity-40': selectedFilters[1] === 'secondhalf'}">1p.</span>
              <div class="absolute left-1/2 h-6 -top-1 !w-[1px] opacity-40 bg-white !rounded-full"></div>
              <span class="lowercase" :class="{'opacity-40': selectedFilters[1] === 'firsthalf'}">2p.</span>
            </div>
					</div>
    			<Transition name="fade" mode="out-in">
    			  <div v-if="loading" class="rounded-zt border border-zt-light mb-4 overflow-hidden">
    			    <div class="bg-zt-light-full w-full h-[45px] flex items-center p-2">
    			      <div class="bg-zt-more w-[150px] opacity-10 rounded-zt h-3"></div>
    			    </div>
    			    <div v-for="i in 5" class="border-b border-zt-light bg-zt-light/35 w-full h-[45px] flex items-center p-2">
    			      <div class="bg-zt-more w-[150px] opacity-10 rounded-zt h-3"></div>
    			    </div>
    			  </div>
						<div v-else>
							<div class="flex flex-col items-start w-full">
								<div v-for="(match, index) of roundsToShow[0]" :key="match.match_id" class="w-full">
          		    <FootballStatsListItem class="border-t-0" :class="{
									'border-r' : noOfRightMatches < noOfLeftMatches && index + 1 > noOfRightMatches,
									'rounded-none rounded-bl-zt' : index === noOfLeftMatches - 1 && (!areAllDisplayed || areAllDisplayed && noOfRightMatches > noOfLeftMatches) && (!hasPreviousYear || noOfRightMatches > noOfLeftMatches),
          		    'rounded-b-zt' : noOfLeftMatches > noOfRightMatches && index === noOfLeftMatches - 1 && !areAllDisplayed && !hasPreviousYear,
          		    'border-b-0' : (areAllDisplayed && noOfLeftMatches > noOfRightMatches && (index === noOfLeftMatches - 1 || index === amountA - 1))
          		    || (hasPreviousYear && noOfLeftMatches >= noOfRightMatches && index === noOfLeftMatches -1),
          		    'rounded-none' : !areAllDisplayedMobileA && index === noOfLeftMatches - 1 }"
                   :mark-winner="markWinner"
                   :displaying-stat="displayingStat"
                   :current-filters="selectedFilters"
                   variant="compact"
                   :show-odds="true"
                   :team-id="teamAId"
                   :redirect-to-h2h="match.is_h2h_available"
                   :show-relative-date="false"
                   :ish2h="true"
                   :short-league-name="match.league_short_name === '' ? 'Liga' : match.league_short_name"
                   :show-teams-bg="['1x2', 'odds'].includes(selectedFilters[0]) ? [+teamAId] : []"
                   :show-promotion-icon="isMatchRoundInPlayOffs(match.round, match)"
                   :filtering-result="calculateFilterResult(match, +match.localteam_id === +teamAId, teamAId)"
                   :match="match" show-date show-animation :show-double-match="false"/>
								</div>
							</div>
              <p class="h-[50px] text-xs grid place-items-center bg-zt-light/35 text-zt-more border-x border-b border-zt-light rounded-b-zt"
                 v-if="noOfLeftMatches === 0 && noOfRightMatches === 0 && (mobileView === 'a' && window.size.mobile)">
                Brak meczów do wyświetlania
              </p>
						</div>
					</Transition>
				</div>
				<div class="flex flex-col">
          <div class="bg-zt-light-full border-b border-r border-zt-light py-2.5 pl-2 text-xs uppercase flex flex-nowrap
                      items-center !h-[41px] max-h-[41px]" :class="[loading ? 'h-fit' : 'h-full']">
            <img class="w-5 h-5 object-contain aspect-square mr-2" :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${teamBQueryName}.png`"
                 @error="$event.target.src='/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
                 :alt="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"/>
            <span v-if="mobileView === 'a'">Mecze {{ homeAway === 'home/away' ? 'wyjazdowe' : teamBDetails.country === 'World' ? '' : 'ligowe' }}
              - {{teamBDetails.shortname ? teamBDetails.shortname : teamBName }} </span>
	          <span class="truncate" v-else>{{teamBDetails.shortname ? teamBDetails.shortname : teamBName }}</span>
            <div v-if="selectedFilters[0] === 'halfs'" class="flex flex-nowrap ml-auto mr-[21px] relative xl:!mr-[25px] font-['lato'] gap-x-2">
              <span class="lowercase" :class="{'opacity-40': selectedFilters[1] === 'secondhalf'}">1p.</span>
              <div class="absolute left-1/2 h-6 -top-1 !w-[1px] opacity-40 bg-white !rounded-full"></div>
              <span class="lowercase" :class="{'opacity-40': selectedFilters[1] === 'firsthalf'}">2p.</span>
            </div>
          </div>
    			<Transition name="fade" mode="out-in">
    			  <div v-if="loading" class="rounded-zt border border-zt-light mb-4 overflow-hidden">
    			    <div class="bg-zt-light-full w-full h-[45px] flex items-center p-2">
    			      <div class="bg-zt-more w-[150px] opacity-10 rounded-zt h-3"></div>
    			    </div>
    			    <div v-for="i in 5" class="border-b border-zt-light bg-zt-light/35 w-full h-[45px] flex items-center p-2">
    			      <div class="bg-zt-more w-[150px] opacity-10 rounded-zt h-3"></div>
    			    </div>
    			  </div>
						<div v-else>
							<div class="flex flex-col items-start w-full">
								<div v-for="(match, index) of roundsToShow[1]" :key="match.match_id" class="w-full">
									<FootballStatsListItem class="border-t-0 border-l-0 pl-px" :class="{
									'!border-l -ml-px !w-[calc(100%+1px)]' : noOfRightMatches > noOfLeftMatches && index + 1 > noOfLeftMatches,
									'rounded-none rounded-br-zt' : index === noOfRightMatches - 1 && (!areAllDisplayed || areAllDisplayed && noOfLeftMatches > noOfRightMatches) && (!hasPreviousYear || noOfRightMatches < noOfLeftMatches),
									'rounded-b-zt' : noOfRightMatches > noOfLeftMatches && index === noOfRightMatches - 1 && !areAllDisplayed && !hasPreviousYear,
									'border-b-0' : (areAllDisplayed && noOfRightMatches > noOfLeftMatches && (index === noOfRightMatches - 1 || index === amountB - 1))
									|| (hasPreviousYear && noOfRightMatches >= noOfLeftMatches && index === noOfRightMatches -1),
									'rounded-none' : !areAllDisplayedMobileB && index === noOfRightMatches - 1 }"
                    :mark-winner="markWinner"
                    :displaying-stat="displayingStat"
								    :team-id="teamBId"
								    variant="compact"
                    :show-odds="true"
                    :current-filters="selectedFilters"
										:show-relative-date="false"
                    :ish2h="true"
                    :short-league-name="match.league_short_name === '' ? 'Liga' : match.league_short_name"
                    :redirect-to-h2h="match.is_h2h_available"
                    :show-teams-bg="['1x2', 'odds'].includes(selectedFilters[0]) ? [+teamBId] : []"
                    :show-promotion-icon="isMatchRoundInPlayOffs(match.round, match)"
                    :filtering-result="calculateFilterResult(match, +match.localteam_id === +teamBId, teamBId)"
                    :match="match" show-date show-animation :show-double-match="false"/>
								</div>
							</div>
						</div>
					</Transition>
				</div>
			</div>
			<div v-if="areAllDisplayed"
			     class="py-4 flex items-center border bg-zt-light/35 border-zt-light justify-center text-zt-more
			            text-xs underline font-normal uppercase rounded-b-zt"
			     :class="{
						'border-t' : noOfLeftMatches !== noOfRightMatches,
						'rounded-tl-zt' : noOfRightMatches > noOfLeftMatches,
					  'rounded-tr-zt' : noOfLeftMatches > noOfRightMatches }">
				<span class="cursor-pointer zt-hover"
              @click="amountA += 5; amountB += 5; countClicks('Analityka ROZWIŃ w PORÓWNANIU  DRUŻYN')">Rozwiń</span>
			</div>
      <p class="h-[50px] text-xs grid place-items-center bg-zt-light/35 text-zt-more border-x  border-zt-light"
         :class="{'rounded-b-zt border-b' : !hasPreviousYear}"
         v-if="noOfLeftMatches === 0 && noOfRightMatches === 0">
        Brak meczów do wyświetlania
      </p>
      <div v-if="hasPreviousYear && !areAllDisplayed" class="h-[50px] text-xs grid place-items-center bg-zt-light/35
         text-zt-more border border-zt-light" :class="{'!rounded-b-zt' : !showLastSeason,
         'border-t' : noOfLeftMatches !== noOfRightMatches,
         'rounded-tl-zt' : noOfRightMatches > noOfLeftMatches,
         'rounded-tr-zt' : noOfLeftMatches > noOfRightMatches}">
            <span class="cursor-pointer underline zt-hover" @click="showLastSeason = !showLastSeason">
              {{showLastSeason ? 'ZWIŃ POPRZEDNI SEZON' : 'ROZWIŃ POPRZEDNI SEZON'}}
              <svg class="transition inline-block ml-1" :class="{ 'rotate-180' : showLastSeason }" xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
                <path d="M1.1972 0L5.09444 3.24417L8.9917 2.98023e-07L10.1889 0.998746L5.09444 5.24875L0 0.998746L1.1972 0Z" fill="#93A3BA"/>
			        </svg>
            </span>
      </div>
		</div>
    <div v-if="showLastSeason && view === 'a'" class="grid grid-cols-1 xl:grid-cols-2" :class="{ 'grid-cols-2' : mobileView === 'b' }">
      <div class="flex flex-col">
        <div v-for="(match, index) of lastSeasonRoundsToShow[0]" :key="match.match_id" class="w-full">
          <FootballStatsListItem class="border-t-0" :class="{
									'border-r' : lastSeasonNoOfRightMatches < lastSeasonNoOfLeftMatches && index + 1 > lastSeasonNoOfRightMatches,
									'rounded-none rounded-bl-zt' : index === lastSeasonNoOfLeftMatches - 1 && (!areAllDisplayed || areAllDisplayed && lastSeasonNoOfRightMatches > lastSeasonNoOfLeftMatches),
          		    'rounded-b-zt' : lastSeasonNoOfLeftMatches > lastSeasonNoOfRightMatches && index === lastSeasonNoOfLeftMatches - 1,
          		    'border-b-0' : (areAllDisplayed && lastSeasonNoOfLeftMatches > lastSeasonNoOfRightMatches && (index === lastSeasonNoOfLeftMatches - 1 || index === amountA - 1)),
          		    'rounded-none' : !areAllDisplayedMobileA && index === lastSeasonNoOfLeftMatches - 1 }"
                                 :mark-winner="markWinner"
                                 :displaying-stat="displayingStat"
                                 :current-filters="selectedFilters"
                                 variant="compact"
                                 :show-league-name="match.league_query_name === 'euro'"
                                 :team-id="teamAId"
                                 :redirect-to-h2h="match.is_h2h_available"
                                 :show-relative-date="false"
                                 :ish2h="true"
                                 :short-league-name="match.league_short_name === '' ? 'Liga' : match.league_short_name"
                                 :show-teams-bg="['1x2', 'odds'].includes(selectedFilters[0]) ? [+teamBId] : []"
                                 :show-promotion-icon="isMatchRoundInPlayOffs(match.round, match)"
                                 :filtering-result="calculateFilterResult(match, +match.localteam_id === +teamAId, teamAId)"
                                 :match="match" show-date show-animation/>
        </div>
      </div>
      <div class="flex flex-col">
        <div v-for="(match, index) of lastSeasonRoundsToShow[1]" :key="match.match_id" class="w-full">
          <FootballStatsListItem class="border-t-0 border-l-0" :class="{
									'!border-l -ml-px !w-[calc(100%+1px)]' : lastSeasonNoOfRightMatches > lastSeasonNoOfLeftMatches && index + 1 > lastSeasonNoOfLeftMatches,
									'rounded-none rounded-br-zt' : index === lastSeasonNoOfRightMatches - 1 && (!areAllDisplayed || areAllDisplayed && lastSeasonNoOfLeftMatches > lastSeasonNoOfRightMatches),
									'rounded-b-zt' : lastSeasonNoOfRightMatches > lastSeasonNoOfLeftMatches && index === lastSeasonNoOfRightMatches - 1,
									'border-b-0' : (areAllDisplayed && lastSeasonNoOfRightMatches > lastSeasonNoOfLeftMatches && (index === lastSeasonNoOfRightMatches - 1 || index === amountB - 1)),
									'rounded-none' : !areAllDisplayedMobileB && index === lastSeasonNoOfRightMatches - 1 }"
                                 :mark-winner="markWinner"
                                 :displaying-stat="displayingStat"
                                 :team-id="teamBId"
                                 variant="compact"
                                 :show-league-name="match.league_query_name === 'euro'"
                                 :current-filters="selectedFilters"
                                 :show-relative-date="false"
                                 :ish2h="true"
                                 :short-league-name="match.league_short_name == '' ? 'Liga' : match.league_short_name"
                                 :redirect-to-h2h="match.is_h2h_available"
                                 :show-teams-bg="['1x2', 'odds'].includes(selectedFilters[0]) ? [+teamBId] : []"
                                 :show-promotion-icon="isMatchRoundInPlayOffs(match.round, match)"
                                 :filtering-result="calculateFilterResult(match, +match.localteam_id === +teamBId, teamBId)"
                                 :match="match" show-date show-animation/>
        </div>
      </div>
    </div>
    <div v-if="view === 'b'" class="border-x border-b border-zt-light">
      <template v-for="narrowStat in narrowStatsTables">
        <NarrowStatMatchList
            v-if="!narrowStat.title.toLowerCase().includes('rożne') || (narrowStat.title.toLowerCase().includes('rożne') && !cornersDeleted)"
            :team-b-id="teamBId"
            :team-a-query-name="teamAQueryName"
            :team-b-query-name="teamBQueryName"
            :team-a-id="teamAId"
            :matches="roundsToShow"
            :filters="narrowStat.filters"
            :options="narrowStat.options"
            :title="narrowStat.title"
            :home-away="homeAway"
            />
      </template>
    </div>
	</div>
  <div v-else class="border-t border-zt-light rounded-zt"></div>
</template>

<script>
import utils_mixin from "../mixins/utils_mixin";
import football_mixin from "../mixins/football_mixin";
import FootballStatsFilter from "../components/FootballStatsFilter.vue";
import FootballStatsListItem from "../components/blocks/FootballStatsListItem.vue";
import FootballStatsListItemIcon from "../components/blocks/FootballStatsListItemIcon.vue";
import NarrowStatMatchList from "../components/football_stats/blocks/NarrowStatMatchList.vue";

export default {
	name: 'FootballStatsCompareResults',
	components: {NarrowStatMatchList, FootballStatsListItemIcon, FootballStatsListItem, FootballStatsFilter},
	emits: ['loaded'],
	mixins: [utils_mixin, football_mixin],
	inject: ['WP'],
	props: {
		teamAId: {
			type: Number,
		},
		teamADetails: {
			type: Object,
		},
		teamBId: {
			type: Number,
		},
		teamBDetails: {
			type: Object,
		},
    view: {
      type: String,
      default: 'a',
    }
	},
	data() {
		return {
			homeAway: 'all',
			mobileView: 'b',
			selectedFilters: [],
      narrowStatsTables: [
        {
          title: '1x2',
          filters: ['1x2'],
          options: []
        },
        {
          title: 'ROŻNE - REZULTAT',
          filters: ['corners', 'result'],
          options: []
        },
        {
          title: 'ROŻNE - OVER/UNDER',
          filters: ['corners', 'overunder'],
          options: [
            {
              name: '7,5',
              value: 7.5,
              options: []
            },
            {
              name: '8,5',
              value: 8.5,
              options: []
            },
            {
              name: '9,5',
              value: 9.5,
              options: []
            },
            {
              name: '10,5',
              value: 10.5,
              options: []
            },
            {
              name: '11,5',
              value: 11.5,
              options: []
            },
            {
              name: '12,5',
              value: 12.5,
              options: []
            },
          ]
        },
        {
          title: 'ŻÓŁTE KARTKI - REZULTAT',
          filters: ['cards', 'yellowcards', 'result'],
          options: []
        },
        {
          title: 'ŻÓLTE KARTKI - OVER/UNDER',
          filters: ['cards', 'yellowcards', 'overunder'],
          options: [
            {
              name: '1,5',
              value: 1.5,
              options: []
            },
            {
              name: '2,5',
              value: 2.5,
              options: []
            },
            {
              name: '3,5',
              value: 3.5,
              options: []
            },
            {
              name: '4,5',
              value: 4.5,
              options: []
            },
            {
              name: '5,5',
              value: 5.5,
              options: []
            },
          ]
        },
        {
          title: 'BTTS',
          filters: ['btts'],
          options: []
        },
        {
          title: 'OVER/UNDER GOLI',
          filters: ['overunder'],
          options: [
            {
              name: '0,5',
              value: 0.5,
              options: []
            },
            {
              name: '1,5',
              value: 1.5,
              options: []
            },
            {
              name: '2,5',
              value: 2.5,
              options: []
            },
            {
              name: '3,5',
              value: 3.5,
              options: []
            },
            {
              name: '4,5',
              value: 4.5,
              options: []
            },
            {
              name: '5,5',
              value: 5.5,
              options: []
            },
          ]
        },
        {
          title: 'POŁOWY',
          filters: ['halfs'],
          options: [
            {
              name: '1. Połowa',
              value: 'firsthalf',
              options: []
            },
            {
              name: '2. Połowa',
              value: 'secondhalf',
              options: []
            },
          ]
        },
        {
          title: 'KARNE',
          filters: ['penalty'],
          options: [
            {
              name: 'Gole Z Karnych',
              value: 'inmatch',
              options: []
            },
            {
              name: 'Gole Drużyna',
              value: 'for',
              options: []
            },
            {
              name: 'Gole Przeciwko',
              value: 'against',
              options: []
            },
          ]
        }
      ],
			filteringOptions: [
				{
					name: '1x2',
					value: '1x2',
					options: []
				},
        {
          name: 'Kursy',
          value: 'odds',
          options: []
        },
				{
					name: 'Rożne',
					value: 'corners',
					options: [
						{
							name: 'Rezultat',
							value: 'result',
							options: []
						},
						{
							name: 'Over/Under',
							value: 'overunder',
							options: [
								{
									name: '7,5',
									value: 7.5,
									options: []
								},
								{
									name: '8,5',
									value: 8.5,
									options: []
								},
								{
									name: '9,5',
									value: 9.5,
									options: []
								},
								{
									name: '10,5',
									value: 10.5,
									options: []
								},
								{
									name: '11,5',
									value: 11.5,
									options: []
								},
								{
									name: '12,5',
									value: 12.5,
									options: []
								},
							]
						}
					]
				},
				{
					name: 'Kartki',
					value: 'cards',
					options: [
						{
							name: 'Żółte',
							value: 'yellowcards',
							options: [
								{
									name: 'Rezultat',
									value: 'result',
									options: []
								},
								{
									name: 'Over/Under',
									value: 'overunder',
									options: [
										{
											name: '1,5',
											value: 1.5,
											options: []
										},
										{
											name: '2,5',
											value: 2.5,
											options: []
										},
										{
											name: '3,5',
											value: 3.5,
											options: []
										},
										{
											name: '4,5',
											value: 4.5,
											options: []
										},
										{
											name: '5,5',
											value: 5.5,
											options: []
										},
									]
								}
							]
						},
            {
              name: 'Czerwone',
              value: 'red',
              options: [
                {
                  name: 'Rezultat',
                  value: 'result',
                  options: [],
                },
                {
                  name: 'Over/Under',
                  value: 'overunder',
                  options: [
                    {
                      name: '0,5',
                      value: 0.5,
                      options: []
                    },
                  ],
                },
              ]
            }
					]
				},
				{
					name: 'BTTS',
					value: 'btts',
					options: []
				},
				{
					name: 'Over/under',
					value: 'overunder',
					options: [
						{
							name: '0,5',
							value: 0.5,
							options: []
						},
						{
							name: '1,5',
							value: 1.5,
							options: []
						},
						{
							name: '2,5',
							value: 2.5,
							options: []
						},
						{
							name: '3,5',
							value: 3.5,
							options: []
						},
						{
							name: '4,5',
							value: 4.5,
							options: []
						},
						{
							name: '5,5',
							value: 5.5,
							options: []
						},
					]
				},
				{
					name: 'Połowy',
					value: 'halfs',
					options: [
						{
							name: '1. Połowa',
							value: 'firsthalf',
							options: []
						},
						{
							name: '2. Połowa',
							value: 'secondhalf',
							options: []
						},
					]
				},
				{
					name: 'Karne',
					value: 'penalty',
					options: [
						{
							name: 'Gole Z Karnych',
							value: 'inmatch',
							options: []
						},
            {
              name: 'Gole Drużyna',
              value: 'for',
              options: []
            },
            {
              name: 'Gole Przeciwko',
              value: 'against',
              options: []
            },
					]
				},
			],
			teamARounds: [],
			teamBRounds: [],
			amountA: 5,
			amountB: 5,
			loading: true,
      borderWidth: 0,
      hasPreviousYear: false,
      teamALastSeasonResults: [],
      teamBLastSeasonResults: [],
      showLastSeason: false,
      cornersDeleted: false
		}
	},
  computed: {
		noOfLeftMatches() {
			return Object.keys(this.roundsToShow[0]).length;
		},
	  noOfRightMatches() {
		  return Object.keys(this.roundsToShow[1]).length;
	  },
    lastSeasonNoOfLeftMatches() {
      return Object.keys(this.lastSeasonRoundsToShow[0]).length;
    },
    lastSeasonNoOfRightMatches() {
      return Object.keys(this.lastSeasonRoundsToShow[1]).length;
    },
    areAllDisplayed() {
      return this.noOfRounds > this.amountA && this.noOfRounds > this.amountB;
    },
    areAllDisplayedMobileA() {
      return window.size.mobile && this.noOfRounds > this.amountA;
    },
    areAllDisplayedMobileB() {
      return window.size.mobile && this.noOfRounds > this.amountB;
    },
    markWinner() {
      return !(this.selectedFilters[0] !== '1x2' && this.selectedFilters[0] !== 'odds');
    },
    roundsToShow() {
      if (!this.loading) {
        if (this.homeAway === 'all') {
          return this.getMatchesToShow(Object.entries(this.teamARounds), Object.entries(this.teamBRounds));
        } else if (this.homeAway === 'home/away') {
          return this.getMatchesToShow(this.homeRounds, this.awayRounds);
        }
      }
    },
    lastSeasonRoundsToShow() {
      if (!this.loading && this.hasPreviousYear) {
        if (this.homeAway === 'all') {
          return this.getMatchesToShow(Object.entries(this.teamALastSeasonResults), Object.entries(this.teamBLastSeasonResults));
        } else if (this.homeAway === 'home/away') {
          return this.getMatchesToShow(this.lastSeasonHomeRound, this.lastSeasonAwayRounds);
        }
      }
    },
    homeRounds() {
      let tempRounds = [];
      let entries = Object.entries(this.teamARounds);
      entries.forEach(round => {
        let filteredMatches = {
          round_matches: round[1].round_matches.slice().filter(match => {
            return +match.localteam_id === this.teamAId;
          })
        }
        if (filteredMatches.round_matches.length > 0) {
          tempRounds.push([round[0], filteredMatches]);
        }
      });
      return tempRounds;
    },
    lastSeasonHomeRound() {
      let tempRounds = [];
      let entries = Object.entries(this.teamALastSeasonResults);
      entries.forEach(round => {
        let filteredMatches = {
          round_matches: round[1].round_matches.slice().filter(match => {
            return +match.localteam_id === this.teamAId;
          })
        }
        if (filteredMatches.round_matches.length > 0) {
          tempRounds.push([round[0], filteredMatches]);
        }
      });
      return tempRounds;
    },
    awayRounds() {
      let tempRounds = [];
      let entries = Object.entries(this.teamBRounds);
      entries.forEach(round => {
        let filteredMatches = {
          round_matches: round[1].round_matches.slice().filter(match => {
            return +match.visitorteam_id === this.teamBId;
          })
        }
        if (filteredMatches.round_matches.length > 0) {
          tempRounds.push([round[0], filteredMatches]);
        }
      });
      return tempRounds;
    },
    lastSeasonAwayRounds() {
      let tempRounds = [];
      let entries = Object.entries(this.teamBLastSeasonResults);
      entries.forEach(round => {
        let filteredMatches = {
          round_matches: round[1].round_matches.slice().filter(match => {
            return +match.visitorteam_id === this.teamBId;
          })
        }
        if (filteredMatches.round_matches.length > 0) {
          tempRounds.push([round[0], filteredMatches]);
        }
      });
      return tempRounds;
    },
    noOfRounds() {
      if (this.homeAway === 'all') {
        let roundsA = Object.values(this.teamARounds);
        roundsA = roundsA.slice().reduce((acc, round) => acc + round.round_matches.length, 0);
        let roundsB = Object.values(this.teamBRounds);
        roundsB = roundsB.slice().reduce((acc, round) => acc + round.round_matches.length, 0);
        return roundsA > roundsB ? roundsA : roundsB
      } else if (this.homeAway === 'home/away') {
        let homeRounds = Object.values(Object.fromEntries(this.homeRounds.slice())).reduce((acc, round) => acc + round.round_matches.length, 0);
        let awayRounds = Object.values(Object.fromEntries(this.awayRounds.slice())).reduce((acc, round) => acc + round.round_matches.length, 0);
        return homeRounds > awayRounds ? homeRounds : awayRounds
      }
    },
    displayingStat() {
      if (this.selectedFilters[0] === 'corners') {
        return 'corners';
      }
      if (this.selectedFilters[0] === 'cards') {
        return 'cards';
      }
      if (this.selectedFilters[0] === 'halfs') {
        return this.selectedFilters[1] === 'firsthalf' ? 'firsthalf' : 'secondhalf'
      }
      if (this.selectedFilters[0] === 'penalty') {
        return 'penalty';
      }
      if (this.selectedFilters[0] === 'btts' || this.selectedFilters[0] === 'overunder' ) {
        return 'ft_goals'
      }
      return 'goals';
    },
    teamAName() {
      return this.teamADetails.name;
    },
    teamBName() {
      return this.teamBDetails.name;
    },
    teamAQueryName() {
      return this.teamADetails.query_name;
    },
    teamBQueryName() {
      return this.teamBDetails.query_name;
    },
  },
  async mounted() {
    const responseA = await axios.post(this.WP.ajaxUrl, {
      endpoint: 'api_get_team_results',
      team_id: this.teamAId,
      is_h2h: false //w przypadku zmiany na mecze ze wszystkich lig
    })
    this.teamARounds = Object.fromEntries(Object.entries(responseA.data.data).filter(round => {
      return this.checkStatus(round[1]['round_matches'][0].status);
    }));
    const responseB = await axios.post(this.WP.ajaxUrl, {
      endpoint: 'api_get_team_results',
      team_id: this.teamBId,
      is_h2h: false //w przypadku zmiany na mecze ze wszystkich lig
    })
    this.teamBRounds = Object.fromEntries(Object.entries(responseB.data.data).filter(round => {
      return this.checkStatus(round[1]['round_matches'][0].status)
    }));

    if([...Object.values(this.teamARounds), ...Object.values(this.teamBRounds)].some((round) => {
      let corners = 0;
      round.round_matches.forEach((match) => {
        corners += Number(match.localteam_corners) + Number(match.visitorteam_corners);
      })
      return corners === 0;
    })) {
      let index = this.filteringOptions.findIndex(el => {
        return el.name === 'Rożne';
      })
      if (index !== -1) {
        this.cornersDeleted = true;
        this.filteringOptions.splice(index, 1);
      }
    }
    await this.getPreviousSeason();
    this.loading = false;
		this.$emit('loaded');
  },
	methods: {
    getMatchesToShow(roundsA, roundsB) {
      let teamA = this.sliceNestedMatches(roundsA,this.view === 'b' ? 1000 : this.amountA).filter(round => {
        return round[1].round_matches.length !== 0
      });
      let teamB = this.sliceNestedMatches(roundsB, this.view === 'b' ? 1000 : this.amountB).filter(round => {
        return round[1].round_matches.length !== 0
      });
      const teamAMatches = [];
      teamA.forEach(round => {
        teamAMatches.push(...round[1].round_matches);
      });
      const teamBMatches = [];
      teamB.forEach(round => {
        teamBMatches.push(...round[1].round_matches);
      });
      return [teamAMatches, teamBMatches];
    },
    sliceNestedMatches(rounds, amount) {
      let tempRounds = [];
      let counter = 0;
      rounds.forEach((round) => {
        if (round[1].round_matches.length + counter <= amount) {
          counter += round[1].round_matches.length;
          tempRounds.push(round);
        } else {
          tempRounds.push([round[0],{
            round_matches: round[1].round_matches.slice(0, amount - counter)
          }]);
          counter = amount;
          return tempRounds
        }
      })
      return tempRounds;
    },
		changeMobileView(view) {
			this.mobileView = view;
			if (view === 'b') {
				this.countClicks('PORÓWNANIE DRUŻYN - Widok B');
				this.amountA = 10;
				this.amountB = 10;
			}
			if (view === 'a') {
				this.countClicks('PORÓWNANIE DRUŻYN  - Widok A');
				this.amountA = 5;
				this.amountB = 5;
			}
		},
		changeHomeAway(value) {
      if (value === 'all') {
        this.countClicks('PORÓWNANIE DRUŻYN - ogółem', 'football');
      } else {
        this.countClicks('PORÓWNANIE DRUŻYN - dom/wyjazd', 'football');
      }
			this.homeAway = value;
		},
		changeFilters(value) {
			if (value[0] !== this.selectedFilters[0]) {
				this.homeAway = 'all';
			}
			this.selectedFilters = value;
		},
		calculateFilterResult(match, isLocal, teamId) {
			if (this.selectedFilters[0] === '1x2') {
				if (match.localteam_goals === match.visitorteam_goals) {
          if (match.localteam_penalty_shootout > 0 || match.visitorteam_penalty_shootout > 0) {
            if (isLocal) {
              return match.localteam_penalty_shootout > match.visitorteam_penalty_shootout ? 'W' : 'P';
            } else {
              return match.visitorteam_penalty_shootout > match.localteam_penalty_shootout  ? 'W' : 'P';
            }
          }
          return 'R';
        }
				if (this.homeAway === 'home/away') {
					if (isLocal) {
						return match.localteam_goals > match.visitorteam_goals ? 'W' : 'P';
					} else {
						return match.visitorteam_goals > match.localteam_goals ? 'W' : 'P';
					}
				} else {
					if (+match.localteam_id === teamId) {
						return match.localteam_goals > match.visitorteam_goals ? 'W' : 'P';
					} else {
						return match.visitorteam_goals > match.localteam_goals ? 'W' : 'P';
					}
				}
			}
			if (this.selectedFilters[0] === 'overunder') {
				const value = this.selectedFilters[1];
        const matchGoals = +match.localteam_goals + +match.visitorteam_goals - +match.localteam_et_goals - +match.visitorteam_et_goals;
        return matchGoals > value ? 'W' : 'P';
			}
			if (this.selectedFilters[0] === 'btts') {
        return +match.localteam_goals - +match.localteam_et_goals > 0 && +match.visitorteam_goals - +match.visitorteam_et_goals > 0 ? 'W' : 'P';
      }
			if (this.selectedFilters[0] === 'corners' && this.selectedFilters[1] === 'overunder') {
				const value = this.selectedFilters[2];
				const matchCorners = +match.localteam_corners + +match.visitorteam_corners;
				return matchCorners > value ? 'W' : 'P';
			}
			if (this.selectedFilters[0] === 'corners' && this.selectedFilters[1] === 'result') {
				if (+match.localteam_corners === +match.visitorteam_corners) {
					return 'R';
				} if (+match.localteam_id === teamId) {
					return +match.localteam_corners > +match.visitorteam_corners ? 'W' : 'P';
				} else {
					return +match.visitorteam_corners > +match.localteam_corners ? 'W' : 'P';
				}
			}
			if (this.selectedFilters[0] === 'cards' && this.selectedFilters[2] === 'overunder') {
				const value = this.selectedFilters[3];
				const matchCards = this.selectedFilters[1] === 'yellowcards' ? +match.localteam_yellowcards + +match.visitorteam_yellowcards :
            +match.localteam_red_cards + +match.visitorteam_red_cards;
				return matchCards > value ? 'W' : 'P';
			}
			if (this.selectedFilters[0] === 'cards' && this.selectedFilters[2] === 'result' && this.selectedFilters[1] === 'yellowcards') {
				if (+match.localteam_yellowcards === +match.visitorteam_yellowcards) {
					return 'R';
				} if (+match.localteam_id === teamId) {
					return match.localteam_yellowcards > match.visitorteam_yellowcards ? 'W' : 'P';
				} else {
					return match.visitorteam_yellowcards > match.localteam_yellowcards ? 'W' : 'P';
				}
			}
      if (this.selectedFilters[0] === 'cards' && this.selectedFilters[2] === 'result' && this.selectedFilters[1] === 'red') {
				if (+match.localteam_red_cards === +match.visitorteam_red_cards) {
					return 'R';
				} if (+match.localteam_id === teamId) {
					return match.localteam_red_cards > match.visitorteam_red_cards ? 'W' : 'P';
				} else {
					return match.visitorteam_red_cards > match.localteam_red_cards ? 'W' : 'P';
				}
			}
			if (this.selectedFilters[0] === 'halfs') {
				if (this.selectedFilters[1] === 'firsthalf') {
					if (match.localteam_ht_goals === match.visitorteam_ht_goals) {
						return 'R';
					} if (+match.localteam_id === teamId) {
						return match.localteam_ht_goals > match.visitorteam_ht_goals ? 'W' : 'P';
					} else {
						return match.visitorteam_ht_goals > match.localteam_ht_goals ? 'W' : 'P';
					}
				} else {
					if ((+match.localteam_goals - +match.localteam_ht_goals - +match.localteam_et_goals) === (+match.visitorteam_goals - +match.visitorteam_ht_goals - +match.visitorteam_et_goals)) {
						return 'R';
					} if (+match.localteam_id === teamId) {
						return (+match.localteam_goals - +match.localteam_ht_goals - +match.localteam_et_goals) > (+match.visitorteam_goals - +match.visitorteam_ht_goals - +match.visitorteam_et_goals) ? 'W' : 'P';
					} else {
						return (+match.localteam_goals - +match.localteam_ht_goals - +match.localteam_et_goals) < (+match.visitorteam_goals - +match.visitorteam_ht_goals - +match.visitorteam_et_goals) ? 'W' : 'P';
					}
				}
			}
			if (this.selectedFilters[0] === 'penalty') {
				if (this.selectedFilters[1] === 'for') {
					if (+match.localteam_id === +teamId) {
						return +match.localteam_penalties > 0 ? 'W' : 'P';
					} else {
						return +match.visitorteam_penalties > 0 ? 'W' : 'P';
					}
				}
        else if (this.selectedFilters[1] === 'against') {
          if (+match.localteam_id === +teamId) {
            return +match.visitorteam_penalties > 0 ? 'W' : 'P';
          } else {
            return +match.localteam_penalties > 0 ? 'W' : 'P';
          }
        }
				return +match.localteam_penalties > 0 || +match.visitorteam_penalties > 0 ? 'W' : 'P';
			}
		},
    calculateBorderWidth() {
      setTimeout(() => {
        this.borderWidth = Math.max(this.$refs["icons-teama"].scrollWidth, this.$refs["icons-teamb"].scrollWidth) + 10;
      }, 100);
    },
    async getPreviousSeason() {
      const [resRoundA, resRoundB] = await Promise.all([
        axios.post(this.WP.ajaxUrl, {
          endpoint: 'api_get_team_results',
          team_id: this.teamAId,
          previous_season: true,
          is_h2h: false //w przypadku zmiany na mecze ze wszystkich lig
        }),
        axios.post(this.WP.ajaxUrl, {
          endpoint: 'api_get_team_results',
          team_id: this.teamBId,
          previous_season: true,
          is_h2h: false //w przypadku zmiany na mecze ze wszystkich lig
        })
      ]);
      this.teamALastSeasonResults = resRoundA.data.data;
      this.teamBLastSeasonResults = resRoundB.data.data;
      if (Object.values(this.teamALastSeasonResults).length > 0) {
        this.hasPreviousYear = true;
      }
    }
	},
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;

}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>